import { render } from "./ManagePeopleUser.vue?vue&type=template&id=065ee274&scoped=true&lang=pug"
import script from "./ManagePeopleUser.vue?vue&type=script&lang=js"
export * from "./ManagePeopleUser.vue?vue&type=script&lang=js"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065ee274"]])

export default __exports__